import { render } from "./CardNote.vue?vue&type=template&id=0869a3f6&scoped=true"
import script from "./CardNote.vue?vue&type=script&lang=js"
export * from "./CardNote.vue?vue&type=script&lang=js"

import "./CardNote.vue?vue&type=style&index=0&id=0869a3f6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0869a3f6"]])

export default __exports__